import React from 'react';
import useViewport from '../../functions/viewport'
import "./GhostUI.scss"

const GhostUI = () => {
  const { width } = useViewport()
  const desktopView = width > 500
  const mobileView = width < 500

  let n = 7

  if (width < 900 && width > 600) {
    n = 5
  } else if (width < 600 && width > 500) {
    n = 4
  } else if (width < 500) {
    n = 2
  }

  return (
    <div className="ghost-card">
      <div className="ghost-category">
        {[...Array(n)].map((_, i) => (
          <div key={i} className="ghost-categories"></div>
        ))}
      </div>
      <div className="ghost-content">
        <div className={`ghost-left-panel ${mobileView ? 'ghost-hide-panel' : ''}`}></div>
        <div className="ghost-right-panel">
          <div className={`${desktopView ? 'ghost-hide-panel' : 'ghost-filter-panel'}`}></div>
          <div className='ghost-list'>
            {[...Array(n)].map((_, i) => (
              <React.Fragment key={i}>
                <div className="ghost-device">
                  <div className="ghost-device-image"></div>
                  <div className="ghost-brand"></div>
                  <div className="ghost-title"></div>
                  <div className="ghost-price"></div>
                </div>
              </React.Fragment>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default GhostUI;